import state from './state';
import mutations from './mutations';
import getters from './getters';
import actions from './actions';

export default {
  name: 'checkout',
  namespaced: true,
  mutations,
  getters,
  actions,
  state() {
    return state;
  }
};